import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useTranslation } from "react-i18next";

export default function LanguageToggle() {
  const { i18n } = useTranslation();

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={i18n.language}
      onChange={(_e, lng) => {
        if (!lng) return;
        i18n.changeLanguage(lng);
        localStorage.setItem("language", lng);
      }}
      sx={{
        height: 28,
        "& .MuiToggleButton-root": {
          px: 1,
          fontSize: "0.75rem",
          color: "inherit",
          borderColor: "rgba(255,255,255,0.4)",
          "&.Mui-selected": {
            bgcolor: "rgba(255,255,255,0.2)",
            color: "inherit",
            "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
          },
          "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
        },
      }}
    >
      <ToggleButton value="de">DE</ToggleButton>
      <ToggleButton value="en">EN</ToggleButton>
    </ToggleButtonGroup>
  );
}
